import { API as e, Resource as t } from "@coveo/platform-client";
// src/resources/InsightPanelConfigsInternalResource.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/insightconfig/v1`;
	}
	listInsightPanelConfigsByProjectId(e, t = {}) {
		return this.api.get(this.buildPath(`${n.baseUrl}/projects/configs`, {
			...t,
			projectId: e
		}));
	}
};
export { n as InsightPanelConfigsInternalResource };

//# sourceMappingURL=InsightPanelConfigsInternalResource.js.map